<div *ngIf="jobsList && jobsList.length > 0">
  <!-- Normal View -->
  <div *ngIf="view === 'normal'" [ngClass]="'job-fields-' + view">
    <table mat-table [dataSource]="jobsDatasource">
      <ng-container matColumnDef="company_name">
        <th mat-header-cell *matHeaderCellDef class="tw-h-8">Company</th>
        <td mat-cell *matCellDef="let element" class="tw-leading-[22px]">
          <a
            *ngIf="element.company_linkedin; else valueOnly"
            href="https://linkedin.com/company/{{element.company_linkedin}}"
            target="_blank">
            {{element.company_name}}
          </a>
          <ng-template #valueOnly>{{element.company_name || element.company?.name}}</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let element">{{element.title}}</td>
      </ng-container>

      <ng-container matColumnDef="started_at">
        <th date-col mat-header-cell *matHeaderCellDef>Started</th>
        <td
          mat-cell
          *matCellDef="let element"
          class="tw-text-xs tw-text-gray-600 dark:tw-text-gray-300">
          {{element.started_at | date: dateFormat(element.metadata?.started_at_year_only): 'UTC'}}
          <span
            *ngIf="element.metadata?.started_at_inferred || element.metadata?.StartedAtInferred"
            class="tw-text-black-white-dynamic tw-text-base">
            *
          </span>
          <span
            *ngIf="internal && element.metadata?.job_detected_lag_months != null"
            [ngClass]="lagClass(element.metadata?.job_detected_lag_months)">
            ({{element.metadata?.job_detected_lag_months}})
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="ended_at">
        <th date-col mat-header-cell *matHeaderCellDef>Ended</th>
        <td
          mat-cell
          *matCellDef="let element"
          class="tw-text-xs tw-text-gray-600 dark:tw-text-gray-300">
          <span *ngIf="!element.ended_at">current</span>
          <span *ngIf="element.ended_at">
            {{element.ended_at | date: dateFormat(element.metadata?.ended_at_year_only): 'UTC'}}
            <span
              *ngIf="element.metadata?.ended_at_inferred || element.metadata?.EndedAtInferred"
              class="tw-text-black-white-dynamic tw-text-base">
              *
            </span>
            <span
              *ngIf="internal && element.metadata?.ended_at_detected_lag_months != null"
              [ngClass]="lagClass(element.metadata?.ended_at_detected_lag_months)">
              ({{element.metadata?.ended_at_detected_lag_months}})
            </span>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="created">
        <th
          date-col
          mat-header-cell
          *matHeaderCellDef
          matTooltip="Was this job created in the last 24 hours?"
          class="tw-w-[80px]">
          New?
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="tw-text-gray-600 dark:tw-text-gray-300 tw-text-base">
          <mat-icon
            *ngIf="element.newly_created"
            matTooltip="Created in the last 24 hours"
            class="tw-mr-2 tw-text-lg">
            grade
          </mat-icon>
          <mat-icon
            *ngIf="element.email && element.email_status =='valid'"
            matTooltip="Valid email exists"
            class="tw-mr-2 tw-text-lg">
            mark_email_read
          </mat-icon>
          <mat-icon
            *ngIf="element.email && element.email_status =='catch-all'"
            matTooltip="Catch-all email exists"
            class="tw-mr-2 tw-text-lg">
            mail
          </mat-icon>
          <mat-icon
            *ngIf="element.email && element.email_status =='best-guess'"
            matTooltip="Best-guess email exists"
            class="tw-mr-2 tw-text-lg">
            mark_email_unread
          </mat-icon>
          <mat-icon
            *ngIf="element.direct_dial_number"
            matTooltip="Direct dial exists"
            class="tw-mr-2 tw-text-lg">
            call
          </mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="jobColumns"></tr>
      <!-- Header always shown in normal view -->
      <tr
        mat-row
        *matRowDef="let row; columns: jobColumns;"
        (click)="selectedJob=row"
        [class.selected-row]="row == selectedJob"></tr>
    </table>
    <div class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400 tw-my-2 tw-ml-2">
      <span class="tw-text-black-white-dynamic tw-text-base">*</span> = inferred
    </div>
    <!-- Inferred note for normal view -->
  </div>

  <!-- Compact View (for AG-Grid embedding, similar to screenshot) -->
  <div *ngIf="view === 'compact'" class="tw-text-sm tw-leading-snug tw-py-2">
    <div
      *ngFor="let job of (jobsList | slice:0: (jobsList.length > 3 ? 3 : jobsList.length) )"
      class="tw-flex tw-flex-wrap tw-items-baseline tw-cursor-pointer tw-px-2 tw-py-1 tw-rounded"
      [ngClass]="job === selectedJob ? 'tw-bg-blue-600 tw-text-white' : 'hover:tw-bg-gray-100 dark:hover:tw-bg-gray-700 tw-text-gray-300'"
      (click)="selectedJob = job">
      <span class="tw-font-bold tw-mr-1.5 tw-text-gray-700 dark:tw-text-gray-100">
        {{job.company_name || job.company?.name}}
      </span>
      <span class="tw-mr-1.5 tw-text-gray-500 dark:tw-text-gray-300">{{job.title}}</span>
      <span
        *ngIf="job.started_at"
        class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400 tw-whitespace-nowrap">
        {{job.started_at | date: (job.metadata?.started_at_year_only ? 'yyyy' : 'MMM yyyy'): 'UTC'}}
        {{job.metadata?.started_at_inferred || job.metadata?.StartedAtInferred ? '*' : ''}}
      </span>
      <span
        *ngIf="job.started_at"
        class="tw-mx-1 tw-text-xs tw-text-gray-500 dark:tw-text-gray-400 tw-whitespace-nowrap">
        -
      </span>
      <span
        *ngIf="job.ended_at"
        class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400 tw-whitespace-nowrap">
        {{job.ended_at | date: (job.metadata?.ended_at_year_only ? 'yyyy' : 'MMM yyyy'): 'UTC'}}
        {{job.metadata?.ended_at_inferred || job.metadata?.EndedAtInferred ? '*' : ''}}
      </span>
      <span
        *ngIf="!job.ended_at && job.started_at"
        class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400 tw-whitespace-nowrap">
        current
      </span>
    </div>
    <div
      *ngIf="jobsList.length > 3"
      class="tw-italic tw-text-gray-500 dark:tw-text-gray-400 tw-mt-0.5 tw-text-xs tw-pl-2">
      and {{jobsList.length - 3}} more...
    </div>
  </div>
</div>

<!-- Job Details Panel -->
<div class="detailsPanel tw-ml-2" *ngIf="selectedJob && !disableDetails">
  <div class="jobDetails tw-flex tw-flex-col md:tw-flex-row tw-gap-4 md:tw-gap-9 tw-text-sm">
    <div class="jobDetailColumn">
      <li>
        <strong>Location:</strong>
        <span class="tw-text-gray-600 dark:tw-text-gray-300">{{selectedJob.location}}</span>
      </li>
      <li>
        <strong>Email:</strong>
        <span class="tw-text-gray-600 dark:tw-text-gray-300">{{selectedJob.email}}</span>
      </li>
      <li>
        <strong>Email Status:</strong>
        <span class="tw-text-gray-600 dark:tw-text-gray-300">{{selectedJob.email_status}}</span>
      </li>
      <li>
        <strong>Direct Dial:</strong>
        <span class="tw-text-gray-600 dark:tw-text-gray-300">
          {{selectedJob.direct_dial_number}}
        </span>
      </li>
    </div>
    <div class="jobDetailColumn">
      <li>
        <strong>Title:</strong>
        <span class="tw-text-gray-600 dark:tw-text-gray-300">{{selectedJob.title}}</span>
      </li>
      <li>
        <strong>Level:</strong>
        <span class="tw-text-gray-600 dark:tw-text-gray-300">{{selectedJob.level}}</span>
      </li>
      <li>
        <strong>Function:</strong>
        <span class="tw-text-gray-600 dark:tw-text-gray-300">{{selectedJob.function}}</span>
      </li>
    </div>
    <div class="jobDetailColumn">
      <li>
        <strong>Company:</strong>&nbsp;
        <a
          *ngIf="selectedJob.company_linkedin || selectedJob.company?.linkedin; else jobCompanyValueOnly"
          href="https://linkedin.com/company/{{selectedJob.company_linkedin || selectedJob?.company?.linkedin}}"
          target="_blank">
          {{selectedJob.company_name || selectedJob?.company?.name}}
        </a>
        <ng-template #jobCompanyValueOnly>
          {{selectedJob.company_name || selectedJob?.company?.name}}
        </ng-template>
      </li>
      <li *ngIf="selectedJob.company_lookup">
        <strong>Lookup:</strong> {{selectedJob.company_lookup}}
      </li>
    </div>
  </div>
  <div class="tw-mt-4 tw-flex">
    <a class="tw-flex tw-items-center" (click)="selectedJob=null">
      <mat-icon class="tw-text-sm tw-mt-2">arrow_back</mat-icon>
      Back
    </a>
  </div>
</div>
